/** The default padding of a card. */
export const DEFAULT_CARD_PADDING = 6;

/** The bottom padding of a card that includes a `CardFooter` component. */
export const CARD_PB_WITH_FOOTER = 4;
